import React, { createContext, useContext } from "react";

import {
  useTopicTypeQuery,
  useTopicTypeNameQuery,
} from "@api/publicationTopicType/publicationTopicType";

type TopicTypeContextType = {
  topicTypeData: Record<string, string> | null;
  topicTypeNameData: Record<string, string> | null;
  isLoading: boolean;
};

const TopicTypeContext = createContext<TopicTypeContextType | null>(null);

export const TopicTypeProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { data: topicTypeData, isLoading: isTopicTypeLoading } =
    useTopicTypeQuery();

  const { data: topicTypeNameData, isLoading: isNameLoading } =
    useTopicTypeNameQuery();

  const isLoading = isTopicTypeLoading || isNameLoading;

  const value = React.useMemo(
    () => ({
      topicTypeData: topicTypeData || null,
      topicTypeNameData: topicTypeNameData || null,
      isLoading,
    }),
    [topicTypeData, topicTypeNameData, isLoading],
  );

  return (
    <TopicTypeContext.Provider value={value}>
      {children}
    </TopicTypeContext.Provider>
  );
};

export const useTopicType = () => {
  const context = useContext(TopicTypeContext);
  if (!context) {
    throw new Error("useTopicType must be used within a TopicTypeProvider");
  }
  return context;
};
